import React, { useState } from "react";
import CommonModal from "../../Settings/components/ResetContext/components/DumpModal";
import ShareSuccessModal from "./ShareSuccessModal";
import { useUsersContext } from "../../../context/usersContext";

const ShareModal = ({ isOpen, onClose, data }) => {
  const [shareAll, setShareAll] = useState(false);
  const [selected, setSelected] = useState([]);
  const [openSuccessMoal, setOpenSuccessMoal] = useState(false);
  const { locationUsers } = useUsersContext();

  const teamMembers = locationUsers?.map((user) => ({
    id: user?._id,
    name: user.userName,
  }));

  const handleSuccessModal = () => setOpenSuccessMoal(!openSuccessMoal);

  const handleShareAll = () => {
    setShareAll(true);
    setSelected([]);
  };

  const handleSelectMember = (member) => {
    setShareAll(false);
    setSelected((prev) =>
      prev.filter((item) => item.id === member.id)?.length > 0
        ? prev.filter((mid) => mid.id !== member.id)
        : [...prev, member]
    );
  };

  return (
    <>
      {!openSuccessMoal && (
        <CommonModal
          title={""}
          onClose={onClose}
          isOpen={isOpen}
          showAlert={false}
        >
          <div className="text-lg font-medium text-center mb-0">
            Share {data?.assistant_name}
          </div>
          <div className="text-sm text-center mt-2.5 mb-10">
            Select which team members you'd like to share this agent with.
          </div>

          <div className="flex justify-between items-center px-7 py-4 border !border-[#d9d9d9] rounded-[5px]">
            <div>
              <div className="font-medium text-sm mb-1">
                Share with all Team Members
              </div>
              <div className="text-[10px] text-[#757575]">
                All Team members will have access to this Agent.
              </div>
            </div>
            <button
              className={`border border-black rounded-lg px-7 py-3 text-xs font-medium transition ${
                shareAll ? "bg-black text-white" : "bg-white text-black"
              }`}
              onClick={handleShareAll}
            >
              Share
            </button>
          </div>

          {/* OR Divider */}
          <div className="flex items-center gap-4 py-3 px-5">
            <div className="flex-1 h-px bg-[#d9d9d9]" />
            <span className="text-[#b3b3b3]">OR</span>
            <div className="flex-1 h-px bg-[#d9d9d9]" />
          </div>

          {/* Select specific members */}
          <div className="border !border-[#d9d9d9] rounded-[5px] p-6">
            <div className="font-medium text-sm mb-2">
              Select specific Team Members
            </div>
            <div className="text-[10px] text-[#757575] mb-5">
              Only selected Team Members will have access to this Agent.
            </div>
            <div className="max-h-56 overflow-y-auto flex flex-col gap-3 pr-2">
              {teamMembers?.map((member) => (
                <div
                  key={member.id}
                  className="flex items-center justify-between border !border-[#d9d9d9] rounded-[5px] p-4 bg-white"
                >
                  <span className="text-sm text-[#111827]">{member.name}</span>
                  <div className="relative h-5 w-5">
                    <input
                      type="checkbox"
                      class="peer absolute w-full h-full z-40 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border !border-[#d9d9d9]"
                      id="check-vertical-list-group"
                      onClick={() => handleSelectMember(member)}
                      disabled={shareAll}
                    />
                    <span class="absolute z-0 text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-3.5 w-3.5"
                        viewBox="0 0 20 20"
                        fill="#009951"
                        stroke="#009951"
                        stroke-width="1"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <button
            className="mt-5 w-full bg-black text-white rounded-[3px] py-4 text-sm font-medium"
            onClick={() => {
              // handle share logic here
              handleSuccessModal();
            }}
          >
            Share now
          </button>
        </CommonModal>
      )}
      {openSuccessMoal && (
        <ShareSuccessModal
          isOpen={openSuccessMoal}
          onClose={handleSuccessModal}
          goBackHandler={onClose}
          data={data}
          selectedMembers={selected.length > 0 ? selected : teamMembers}
        />
      )}
    </>
  );
};

export default ShareModal;
